// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tr__ft2CmZ1eL4>td,.card__EtI6AOv_RE{background-color:var(--dixa-color-purple-100)}.card__EtI6AOv_RE{border-color:var(--dixa-color-purple-200)}`, "",{"version":3,"sources":["webpack://./src/app/views/layout/views/dashboard/views/favorite/components/favorite/favoriteDashboardFavorite.module.scss"],"names":[],"mappings":"AAAA,qCAEE,6CAAA,CAGF,kBACE,yCAAA","sourcesContent":[".tr > td,\n.card {\n  background-color: var(--dixa-color-purple-100);\n}\n\n.card {\n  border-color: var(--dixa-color-purple-200);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tr": `tr__ft2CmZ1eL4`,
	"card": `card__EtI6AOv_RE`
};
export default ___CSS_LOADER_EXPORT___;
